<template>
  <base-section
    id="partner-conferences"
    :space="0"
  >
    <v-container>
    <base-section-heading
    title="Partner Conferences"
    color="secondary"
    align="left"
    :toColor="true"
    >
      </base-section-heading>
    <v-row>
      <template v-for="(sponsor, i) in sponsors">
        <v-col
        :key="i"
        cols="12"
        md="3"
        sm="12"
        class="align-self-center"
        >
        <a
          :href="sponsor.to"
          target="_blank"
        >
          <base-img
          v-bind="sponsor"
          color="grey"
          contain
          height="70"
          width="164"
          />
        </a>
        </v-col>
      </template>
    </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'PartnerConferences',

    data: () => ({
        sponsors: [
            {
            src: require('@/assets/ddecs.png'),
            to: 'https://cas.polito.it/DDECS2025/',
            },
        ],
    }),
  }
</script>
